import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import { registerServiceWorker } from './push.ts';
import { captureInstallPrompt } from './useInstallPrompt.ts';
import { applyDocumentLocale } from './format.ts';
import { I18nProvider } from './i18n.tsx';
import './styles.css';

// Before first paint. `dir` is what every logical CSS property in the sheet
// resolves against, so setting it after render would lay the app out in one
// direction and then flip it. The HTML deliberately ships without lang/dir:
// they were hardcoded to Hebrew, which made one market's layout the default for
// the world.
applyDocumentLocale(
  new URLSearchParams(window.location.search).get('locale') ??
    localStorage.getItem('vav.locale') ??
    undefined,
);

// Register early: the worker must already be installed when the user later
// grants notification permission, and it also enables offline shell caching.
void registerServiceWorker();

// Before the first render. Chrome fires beforeinstallprompt within milliseconds
// of load, so a listener attached from a component effect arrives too late and
// the install button never appears.
captureInstallPrompt();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <I18nProvider>
      <App />
    </I18nProvider>
  </StrictMode>,
);

